/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }


      // Add popstate listener to handle back/forward navigation --- Netsteps
      this.setupPopstateListener();
    }


  //Netsteps edit, added a setupPopstateListener
  setupPopstateListener() {
      window.addEventListener('popstate', (event) => {
        if (event.state && event.state.page) {
          const page = event.state.page;
          const url = document.location.pathname + '?page=' + page;

          fetch(url)
            .then(response => response.text())
            .then((responseText) => {
              const html = responseText;
              const gridContent = new DOMParser()
                .parseFromString(html, 'text/html')
                .getElementById('product-grid').innerHTML;

              this.grid.innerHTML = gridContent;
            })
            .catch((error) => {
              console.error('Error handling popstate:', error);
            });
        }
      });
    }
    
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
          
          // Dispatch the custom event after rendering products
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          
        });
    }

    //New updated method to paginate url when tapping Load More button - Netsteps ---
    /*loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
    
      if (base.getAttribute('loading')) {
        return;
      }
    
      base.setAttribute('loading', true);
    
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
    
          // Check if the returned response contains the grid of products
          const gridToReplace = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('product-grid');
    
          if (!gridToReplace || !gridToReplace.querySelectorAll('.column').length) {
            // No more products, hide the Load More button
            base.button.classList.add('visually-hidden');
            base.removeAttribute('loading');
            return;
          }
    
          // Render the new products
          base.renderProducts(html, url);
    
          // Update the browser's URL to reflect the new page
          const newUrl = document.location.pathname + base.addUrlParam(document.location.search, 'page');
          window.history.pushState({ page: base.i }, '', newUrl);
    
          // Increment the page counter AFTER loading and updating the URL
          base.i++;
    
          // Dispatch custom events for tracking or integrations
          dispatchCustomEvent('pagination:page-changed', { url: newUrl });
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        })
        .catch((error) => {
          console.error('Error loading products:', error);
        })
        .finally(() => {
          base.removeAttribute('loading');
        });
    }*/
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}